import React from 'react';
import SvgIcon from './SvgIcon';

const Hotel = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M21.479 23a.5.5 0 01-.5.5h-18a.5.5 0 01-.5-.5V7.5h19V23zM2.48 13.5h19M.521 7.5h22.958M9.48 2.5h4.999M1.48 7.5l2.361-4.724a.5.5 0 01.448-.276H6.48M17.479 2.5h2.193a.5.5 0 01.446.275L22.5 7.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.979 9.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM14.979 9.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM9.98 9.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM5.98 9.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM14.479 23.5V19a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v4.5M18.979 15.5h-2a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM6.98 15.5h-2a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM17.479 1a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v4.5h3V1zM9.48 1a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v4.5h3V1z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Hotel.displayName = 'HotelIcon';

export default Hotel;
